import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styles from './UserAccessibility.module.scss';
import {
	Grid,
	Checkbox,
	FormControlLabel,
	Button,
	Paper,
	FormGroup,
} from '@mui/material';

const UserAccessibility = (props) => {
	const {
		accessibilitiesByRole,
		accessibilities,
		accessibilityCheckbox,
		setAccessibilityCheckbox,
	} = props;
	const [selectAll, setSelectAll] = useState(false);

	useEffect(() => {
		setAccessibilityCheckbox(accessibilitiesByRole);
	}, [accessibilitiesByRole]);

	useEffect(() => {
		if (selectAll) {
			let accessibilitiesObj = {};
			for (let accessibility of accessibilities) {
				let features = accessibility.features;
				let featuresArr = [];
				if (features) {
					featuresArr = Object.keys(features);
				}
				for (let featureKey of featuresArr) {
					let feature = features[featureKey];
					let actions = feature?.actions;
					if (!actions) {
						actions = [];
					}
					for (let action of actions) {
						accessibilitiesObj[
							`${accessibility?.moduleId}-${featureKey}-${action?.actionId}`
						] = true;
					}
				}
			}
			setAccessibilityCheckbox(accessibilitiesObj);
		} else {
			setAccessibilityCheckbox({});
		}
	}, [selectAll]);

	const handleActionCheckboxChange = (event, key) => {
		setAccessibilityCheckbox({
			...accessibilityCheckbox,
			[key]: event.target.checked,
		});
	};

	const handleSelectAll = (event) => {
		setSelectAll(event.target.checked);
	};

	const handleResetDefaultActions = () => {
		setAccessibilityCheckbox(accessibilitiesByRole);
	};

	return (
		<div className={styles.user_accessibility}>
			<div className={styles.header_btn_group}>
				<FormGroup>
					<FormControlLabel
						control={
							<Checkbox
								sx={{
									'&.Mui-checked': {
										color: 'var(--primary)',
									},
								}}
								checked={selectAll}
								onChange={handleSelectAll}
							/>
						}
						label='Select all/Deselect all'
					/>
				</FormGroup>
				<Button
					className={styles.reset_default_actions_btn}
					onClick={handleResetDefaultActions}
				>
					Reset Default Actions
				</Button>
			</div>
			<Paper className={styles.action_groups}>
				{accessibilities?.map((accessibility) => {
					let features = accessibility.features;
					let featuresArr = [];
					if (features) {
						featuresArr = Object.keys(features);
					}

					return (
						<div
							key={accessibility.moduleId}
							className={styles.module}
						>
							<h3 className={styles.module_title}>
								{accessibility.moduleName}
							</h3>
							<Grid container spacing={1}>
								{featuresArr.map((featureKey, index) => {
									let feature = features[featureKey];
									let actions = feature?.actions;

									if (actions && feature) {
										return (
											<Grid
												container
												item
												xs={12}
												key={index}
												spacing={1}
											>
												<Grid item xs={12}>
													<h3
														className={
															styles.feature_title
														}
													>
														{feature.featureName}
													</h3>
												</Grid>
												{actions.map(
													(action, index) => {
														return (
															<Grid
																item
																xs={6}
																key={index}
															>
																<FormGroup>
																	<FormControlLabel
																		control={
																			<Checkbox
																				sx={{
																					'&.Mui-checked':
																						{
																							color: 'var(--primary)',
																						},
																				}}
																				onChange={(
																					event
																				) =>
																					handleActionCheckboxChange(
																						event,
																						`${accessibility?.moduleId}-${featureKey}-${action?.actionId}`
																					)
																				}
																				checked={
																					accessibilityCheckbox[
																						`${accessibility?.moduleId}-${featureKey}-${action?.actionId}`
																					]
																						? true
																						: false
																				}
																			/>
																		}
																		label={
																			action.actionTitle
																		}
																	/>
																</FormGroup>
															</Grid>
														);
													}
												)}
											</Grid>
										);
									}
								})}
							</Grid>
						</div>
					);
				})}
			</Paper>
		</div>
	);
};

const mapStateToProps = (state) => ({
	accessibilities: state.userManagement.accessibilities,
	accessibilitiesByRole: state.userManagement.accessibilitiesByRole,
});
export default connect(mapStateToProps)(UserAccessibility);
